import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";

class MessageArea extends React.Component {
    render() {
        let store = this.props.store;
        let state = store.getState();
        let stylesToApply = "w3-show w3-center w3-padding-small"
                + " w3-" + get(state, "messageAreaBackgroundColor", "white")
                + " w3-text-" + get(state, "messageAreaTextColor", "green");

        return (
            <div id="messageArea" className={state.messageAreaVisible ? stylesToApply : "w3-hide"}>
                {state.messageAreaText}
            </div>
        );
    }
}

MessageArea.contextTypes = {
    sendUrlLinkFn: PropTypes.func
};

export default MessageArea;
